import React, { useState } from 'react';

import RequestService from "../../services/request.service";

import AuthService from '../../features/auth/auth.service'

import { Button, Modal } from 'react-bootstrap';

import { toast } from 'react-toastify'

import DatePicker, { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import es from 'date-fns/locale/es';

import moment from 'moment'

import Dialog from '../../services/Dialogs'

const ModalNuevoPeriodo = ( params : any ) => {

  const user = AuthService.getCurrentUser()

  const { show, handleClose, handleCloseSuccess, periodo_actual } = params


  const [startDate, setStartDate] = useState<any>(new Date(periodo_actual.fecha_fin));


const dialog = new Dialog();

const [ envio_server, setSeEnvio ] = useState<boolean>(false)
const enviarFormulario = async (event:any) =>{

      await dialog.open({
        accept: 'Si',
        cancel: 'Espera',
        dialogClass: '',
        message: '¿Estás seguro?',
        target: event.target,
        template: `<small>Crear un nuevo Periodo de servicio afectará <br/>completamente el funcionamiento del sistema</small>`
      })
      let dialogo : any = await dialog.waitForUser()
      if(dialogo){
        try{

        setSeEnvio(true)
        let res_ = await RequestService.create( `periodos/creacion_periodo` , { fecha_fin : moment(startDate).format('YYYY-MM-DD') })

        if(res_){
          toast.success('Consulta_correcta')
          setTimeout(()=>{
            handleCloseSuccess()
          },0)
        }
        else{
          toast.error('Problemas...')
        } 
        }
        catch(e:any){

          if (e.response?.status) {
            switch (e.response.status) {
              case 404:
                toast.error("No pudimos realizar la acción")
                break;
              default:
                toast.error(e.response?.data)
            }
          }
          else{
            toast.error("Problemas con la busqueda")
          }
          setSeEnvio(false)

        }
        
      }
     
}

  return (
    <>
      <Modal show={show} size="sm" onHide={handleClose} backdrop="static">
        <Modal.Header closeButton>
          <Modal.Title>Nuevo Periodo</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {
            // JSON.stringify(periodo_actual)
          }

          <DatePicker
            selected={startDate}
            minDate={new Date(periodo_actual.fecha_fin)}
            onChange={(date) => setStartDate(date)}
            inline
          />


        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Cancelar
          </Button>
          <Button variant="success" onClick={enviarFormulario} type="button">Ok</Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}


export default ModalNuevoPeriodo;